export default __webpack_public_path__ + "static/media/CX.859cd00d.svg";